import {
  CarryOutOutlined,
  FormOutlined,
  InboxOutlined,
  SolutionOutlined,
  SisternodeOutlined,
  UserOutlined,
  CreditCardOutlined,
  PercentageOutlined,
  LikeOutlined,
  AreaChartOutlined,
  DashboardOutlined,
  StockOutlined,
  MailOutlined,
  DollarOutlined,
  FileSearchOutlined,
} from "@ant-design/icons";

export const getSidebarData = (userPermission) => {
  const result = [];

  if (userPermission.createLead || userPermission?.isAdmin) {
    result.push({
      key: "lead",
      icon: <FormOutlined />,
      label: "Новая заявка",
      link: "/",
    });
  }

  if (userPermission.clients || userPermission?.isAdmin) {
    result.push({
      key: "client",
      icon: <SolutionOutlined />,
      label: "Клиенты",
      link: "/client",
    });
  }

  if (userPermission.products || userPermission?.isAdmin) {
    result.push({
      key: "product",
      icon: <InboxOutlined />,
      label: "Товары",
      link: "/product",
    });
  }

  if (userPermission?.isLocalAdmin || userPermission?.isAdmin) {
    result.push({
      key: "user",
      icon: <UserOutlined />,
      label: "Пользователи",
      link: "/user",
    });
  }

  if (userPermission?.orderStatus || userPermission?.isAdmin) {
    result.push({
      key: "status",
      icon: <CarryOutOutlined />,
      label: "Статусы заказов",
      link: "/status",
    });
  }

  if (userPermission?.assemblyStatus) {
    result.push({
      key: "assembly status",
      icon: <CarryOutOutlined />,
      label: "Статусы сборки",
      link: "/assembly_status",
    });
  }

  if (userPermission?.manufactureStatus) {
    result.push({
      key: "manufacture status",
      icon: <CarryOutOutlined />,
      label: "Статусы производства",
      link: "/manufacture_status",
    });
  }

  if (userPermission?.deliveryStatus) {
    result.push({
      key: "delivery status",
      icon: <CarryOutOutlined />,
      label: "Статусы доставки",
      link: "/delivery_status",
    });
  }

  if (userPermission?.dashboard || userPermission?.isAdmin) {
    result.push({
      key: "dashboard",
      icon: <AreaChartOutlined />,
      label: "Дешборд",
      link: "/dashboard",
    });
  }

  if (userPermission?.installationStatus) {
    result.push({
      key: "installation status",
      icon: <CarryOutOutlined />,
      label: "Статусы монтажа",
      link: "/installation_status",
    });
  }

  if (userPermission?.isAdmin) {
    result.push({
      key: "supplies",
      icon: <SisternodeOutlined />,
      label: "Снабжения",
      link: "/supplies",
    });
  }

  if (userPermission?.isAdmin) {
    result.push({
      key: "entity",
      icon: <CreditCardOutlined />,
      label: "Реквизиты",
      link: "/entity",
    });
  }

  if (userPermission?.isAdmin) {
    result.push({
      key: "partners",
      icon: <PercentageOutlined />,
      label: "Партнеры",
      link: "/kepler-partner",
    });
  }

  if (userPermission?.isAdmin) {
    result.push({
      key: "nps",
      icon: <LikeOutlined />,
      label: "NPS",
      link: "/nps",
    });
  }

  if (userPermission?.isAdmin || userPermission?.supportDepartment || userPermission?.distribution) {
    result.push({
      key: "distribution",
      icon: <CarryOutOutlined />,
      label: "Распределение",
      link: "/distribution",
    });
  }

  if (userPermission?.isAdmin) {
    result.push({
      key: "notifications",
      icon: <MailOutlined />,
      label: "Рассылка",
      link: "/notifications",
    });
  }

  // Мои финансы - доступно всем пользователям
  result.push({
    key: "my-finances",
    icon: <DollarOutlined />,
    label: "Мои финансы",
    link: "/my-finances",
  });

  if (userPermission?.isAdmin) {
    result.push({
      key: "health-monitor",
      icon: <DashboardOutlined />,
      label: "Статус системы",
      link: "/health-monitor",
    });
  }

  // Kepler Sales Hub – точные флаги с бэка
  const canSeeKeplerRob = Boolean(
    userPermission?.isAdmin ||
    userPermission?.keplerRob ||
    userPermission?.keplerRobAdmin ||
    userPermission?.salesDepartment
  );

  if (canSeeKeplerRob) {
    result.push({
      key: "kepler-rob",
      icon: <StockOutlined />,
      label: "Kepler Sales Hub",
      link: "/kepler-rob",
    });
  }

  // Лог сверки данных - только для админов
  if (userPermission?.isAdmin) {
    result.push({
      key: "audit-log",
      icon: <FileSearchOutlined />,
      label: "Лог сверки",
      link: "/kepler-rob/audit-log",
    });
  }

  return result;
};
